import axios from 'axios'

export default() => {
    return axios.create({
        baseURL: `https://xfu87qi6zi.execute-api.us-east-1.amazonaws.com/dev`,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}